import { useAsyncEffect } from '@xylabs/sdk-react'
import { useContext, useState } from 'react'

import { EntityContext } from '../../Contexts'
import { Property } from '../Property'

const GeotokenCountProperty: React.FC = () => {
  const entity = useContext(EntityContext)
  const [count, setCount] = useState<number>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const count = await entity?.getGeotokenList()?.getGeotokenCount()
      if (isMounted()) {
        setCount(count)
      }
    },
    [entity],
  )

  return <Property title="Geotoken Count" value={count} />
}

export default GeotokenCountProperty
